module.exports = __webpack_public_path__ + "img/gzcode.49b01762.jpg";